import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CallToAction from "@/components/CallToAction";
import FacebookFeed from "@/components/FacebookFeed";
import MediaCoverage from "@/components/MediaCoverage";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Facebook, Newspaper } from "lucide-react";

const News = () => {
  return (
    <>
      <Helmet>
        <title>Campaign News & Media Coverage | Matt Bucher for State Representative</title>
        <meta
          name="description"
          content="Stay updated with the latest news and media coverage from Matt Bucher's campaign for State Representative in Delaware's 33rd District."
        />
        <link rel="canonical" href="https://votebucher.com/news" />
        <meta property="og:url" content="https://votebucher.com/news" />
      </Helmet>

      <div className="min-h-screen flex flex-col">
        <Header />

        <main id="main-content" className="flex-grow">
          {/* Hero Banner */}
          <section className="bg-secondary py-20" aria-labelledby="news-heading">
            <div className="container mx-auto px-4 text-center">
              <h1 id="news-heading" className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-secondary-foreground mb-4">
                Campaign News & Media
              </h1>
              <p className="font-body text-xl text-secondary-foreground/80 max-w-2xl mx-auto">
                Updates from the trail and coverage from local media
              </p>
            </div>
          </section>

          {/* Tabbed Content Section */}
          <section className="py-16 bg-background" aria-label="News and media content">
            <div className="container mx-auto px-4">
              <Tabs defaultValue="social" className="w-full">
                <div className="flex justify-center mb-8">
                  <TabsList className="bg-secondary/10 p-1 rounded-full">
                    <TabsTrigger 
                      value="social" 
                      className="rounded-full px-6 py-2.5 data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground font-body font-semibold gap-2"
                    >
                      <Facebook className="h-4 w-4" />
                      Social Media
                    </TabsTrigger>
                    <TabsTrigger 
                      value="media" 
                      className="rounded-full px-6 py-2.5 data-[state=active]:bg-secondary data-[state=active]:text-secondary-foreground font-body font-semibold gap-2"
                    >
                      <Newspaper className="h-4 w-4" />
                      In The News
                    </TabsTrigger>
                  </TabsList>
                </div>

                <TabsContent value="social" className="mt-0">
                  <FacebookFeed />
                </TabsContent>

                <TabsContent value="media" className="mt-0">
                  <MediaCoverage />
                </TabsContent>
              </Tabs>
            </div>
          </section>

          <CallToAction />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default News;
